import ParameterErrors from '../errors/ParameterErrors';
import Handle from '../core/Handle';

const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class StylesHelper{
	static appendCssToPage(cssString){
		const head = document.head || document.getElementsByTagName('head')[0];
		const style = document.createElement('style');
		head.appendChild(style);
		style.type = 'text/css';
		if (style.styleSheet){
			// This is required for IE8 and below.
			style.styleSheet.cssText = cssString;
		} else {
			style.appendChild(document.createTextNode(cssString));
		}
		let disposed = false;
		return new Handle({dispose:()=>{
			if(disposed)return;
			head.removeChild(style);
			disposed = true;
		}});
	}
}